export default __webpack_public_path__ + "static/media/uploadFrame.6b0b075d.png";